module.exports = __webpack_public_path__ + "static/babbels-app-3938da832b76a4cb1829916ae6490f23.jpg";